module.exports = __webpack_public_path__ + "img/notice-server3.7787963a.jpg";